var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 290,
    viewBox: "0 0 292 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.129 57.112L193.645 144.99L282.109 232.868C288.429 239.142 291.98 247.652 291.982 256.526C291.983 265.399 288.436 273.911 282.119 280.187C275.802 286.463 267.234 289.99 258.299 289.992C249.364 289.993 240.794 286.47 234.474 280.197L145.99 192.318L57.5059 280.197C51.1865 286.467 42.6177 289.988 33.6845 289.985C24.7512 289.981 16.1853 286.453 9.87121 280.177C3.55708 273.901 0.011919 265.391 0.0156287 256.519C0.0193384 247.646 3.57161 239.139 9.89099 232.868L98.3357 144.99L9.89099 57.112C3.57161 50.8411 0.0193377 42.3339 0.0156279 33.4618C0.0119181 24.5898 3.55708 16.0796 9.87121 9.80355C16.1853 3.52745 24.7512 -0.000489919 33.6845 -0.00417433C42.6177 -0.00785874 51.1865 3.51302 57.5059 9.7839L145.99 97.6621L234.474 9.7839C240.794 3.50781 249.365 -0.0180664 258.302 -0.0180664C267.239 -0.0180664 275.81 3.50781 282.129 9.7839C288.448 16.06 291.999 24.5722 291.999 33.4479C291.999 42.3237 288.448 50.8359 282.129 57.112Z",
    fill: "#00397D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b5ee4653d6ca6250cf80f784dbc7a800.svg";
export { ForwardRef as ReactComponent };